module.exports = __webpack_public_path__ + "static/4-formation-deformation-s-v-c5995bf747f193224d1cfab872471683.jpg";